import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageOut"><Path fillRule="evenodd" clipRule="evenodd" d="M3.00015 3H21.0002V21H13.0002V19H19.0002V5H16.0002V10H8.00015V5H5.00015V10H3.00015V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M5.91436 14L4.91436 15H7.00015C8.65701 15 10.0002 16.3431 10.0002 18V21H8.00015V18C8.00015 17.4477 7.55244 17 7.00015 17H4.91436L5.91436 18L4.50015 19.4142L1.08594 16L4.50015 12.5858L5.91436 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageOut;
